module.exports = __webpack_public_path__ + "static/media/ylqx.0eee3f98.png";